import thumb from '../../../assets/images/mangahaven/thumb.png';
import full01 from '../../../assets/images/mangahaven/full01.png';

const mangaHavenData = {
  name: 'MangaHaven',
  description: `An online manga reader.`,
  skills: ['CSS3', 'JavaScript', 'React'],
  sources: [
    { caption: "MangaHaven Demo", source:"https://user-images.githubusercontent.com/55158465/253188295-4a84df32-0f57-4869-a429-6c4ee3b128b8.gif" },
    { caption: 'Google Search results for \'mangahaven\'', source: full01 },

  ],
  thumbnail: thumb,
  repoUrl: 'https://github.com/justsolomon/mangahaven',
  liveUrl: 'https://mangahaven.netlify.app/',
};

export default mangaHavenData;
